// Removes all characters that are not in the Latin-1 character set
const stripNonLatin1 = (text = '') => {
  try {
    return text.replace(/[^\x00-\xFF]/g, '');
  }
  catch (error) {
    return text;
  }
};

export default stripNonLatin1;